import './App.css';
import { GiBasket } from 'react-icons/gi';
import { MdClose } from 'react-icons/md';
import { useState,useEffect } from 'react';
import { CartProvider } from "react-use-cart";
import Header from './componenets/Header';
import Slideshow from './componenets/Slider';
import Navbar from './componenets/Navbar';
import SearchBar from './componenets/SearchBar';
import AddCart from './componenets/Cart/AddCart';
import SectionA from './componenets/Sections/SectionA';
// import SectionB from './componenets/Sections/SectionB';
import SectionC from './componenets/Sections/SectionC';
import SectionD from './componenets/Sections/SectionD';
import SectionE from './componenets/Sections/SectionE';
import SectionF from './componenets/Sections/SectionF';
import SectionG from './componenets/Sections/SectionG';
import Footer from './componenets/Footer';

const themeLayout =[{
  id:"header",
  header:"none" //for No Display use "none" and for Visiblity use "block"
}]

function App(props) {


  const [isCartButtonClicked, setCartButtonClicked] = useState(false);
  const handleCartButtonClick = () => {
    setCartButtonClicked(!isCartButtonClicked);
  };
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setScreenSize(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function setColor (){
    document.documentElement.style.setProperty('--main-color',props.maincolor);
    document.documentElement.style.setProperty('--secondary-color',props.secondarycolor);
    document.documentElement.style.setProperty('--text-color',props.textcolor);
    document.documentElement.style.setProperty('--card-color',props.cardcolor);
    document.documentElement.style.setProperty('--background-color',props.backgroundcolor);
    document.documentElement.style.setProperty('--name-color',props.namecolor);
    document.documentElement.style.setProperty('--description-color',props.descriptioncolor);
    document.documentElement.style.setProperty('--header-color',props.headercolor);
    document.documentElement.style.setProperty('--footer-color',props.footercolor);
    document.documentElement.style.setProperty('--footerlink-color',props.footerlinkcolor);
  }
   setColor()
   const [PlaceOrderModalOpen, setPlaceOrderModalOpen] = useState(false);

   const Logo = () => {
    
    const logo = (screenSize < 1503 && isCartButtonClicked ) ? <MdClose className="cart" /> : <GiBasket className="cart" />;
       return logo;

     };
   
   const PlaceOrderOpen = () => {
     setPlaceOrderModalOpen(true);
 
     // Disables Background Scrolling whilst the SideDrawer/Modal is open
     if (typeof window != 'undefined' && window.document) {
       document.body.style.overflow = 'hidden';
     }
   }
   const ClosePlaceOrder = () => {
     setPlaceOrderModalOpen(false);
 
     // Disables Background Scrolling whilst the SideDrawer/Modal is open
     document.body.style.overflow = 'unset';
   }
  return (
   
    <div className="container">
      {themeLayout.map((display) => (
      <Header number="tel:2348101234567" lat="24.84538526818595" lng="66.99110440376445" displayHeader={display.header} 
       key={display.id}
       screenSize={screenSize}
       isCartButtonClicked={isCartButtonClicked} 
       onCartButtonClick={handleCartButtonClick} /> ))}
      {/* Please provide number in "tel: number " */}
      {/* lat= latitude , lng= longitude */}
      <Slideshow />
      <Navbar />
      <CartProvider>

      {(screenSize < 1503 || isCartButtonClicked) && (
      <button className='cartBtn' onClick={handleCartButtonClick}>  
      <Logo  isCartButtonClicked={isCartButtonClicked} screenSize={screenSize} />
      </button>)}

      {(screenSize > 1503 || isCartButtonClicked) && (
      <AddCart PlaceOrderOpen={PlaceOrderOpen} PlaceOrderModalOpen={PlaceOrderModalOpen} ClosePlaceOrder={ClosePlaceOrder} />)}
      <SearchBar />
      <>
      <SectionF Heading="BUDGET DEALS" id='budgetdeals'/>
      <SectionC Heading="BBQ PLATTERS" id='bbqplatters'/>
      <SectionA Heading="POPULAR"  id='popular'/>  
      <SectionD Heading="TREAT BOXES"  id='treat'/>
      <SectionG Heading="BURGERS 1"  id='burgers1'/>
      <SectionG Heading="BURGERS 2"  id='burgers2'/>
      <SectionG Heading="BURGERS 3"  id='burgers3'/>
      <SectionE Heading="EXTRAS"  id='extras'/>
      </>
      </CartProvider>
      <Footer />
    
    </div>
  );
}

export default App;
